module.exports = "images/yellow.9bbb91cc38b076dd5e34c92d348b4e1d.png";